import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import React, { useEffect, useRef, useState } from "react";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import "../../../assets/topstudio/styles/Player.css";
import Volume from "./Volume";
import axiosInstance from "../../../utils/axiosInstance";
import OneCardMeterRules from "./pop-up/OneCardMeter-rules";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import { setUserData } from "../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import OneCardMeterResult from "./tp-result/OneCardMeterResult.jsx";

export default function OneCardMeter() {
  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [roundId, setRoundId] = useState("");
  const [resultData, setResultData] = useState([]);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [winnerA, setWinnerA] = useState(false);
  const [playerABook, setPlayerABook] = useState(0);
  const [playerBBook, setPlayerBBook] = useState(0);
  const [playerALoos, setPlayerALoss] = useState(0);
  const [playerBLoss, setPlayerBLoss] = useState(0);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [b1Val, setB1Val] = useState(0);
  const [b2Val, setB2Val] = useState(0);
  const [lastStatus, setLastStatus] = useState(null);
  const [winnerB, setWinnerB] = useState(false);
  const [isPair1, setIsPair1] = useState(false);
  const [isPair2, setIsPair2] = useState(false);
  const [resultList, setResultList] = useState([]);
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [initialBetsFetched, setInitialBetsFetched] = useState(false);
  const sessionUser = useSelector((s) => s.userStore.data);

  const updateUserData = async (userData) => {
    //await dispatch(setUserData(userData));
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  const [shownCards, setShownCards] = useState({
    ac1: "1",
    ac2: "1",
    ac3: "1",
    bc1: "1",
    bc2: "1",
    bc3: "1"
  });

  /* ================= SEQUENTIAL CARD REVEAL ================= */
  const flipTimerRef = useRef(null);
  const cardsSettleTimerRef = useRef(null);
  const revealStartedForRef = useRef(null);
  const [shownAc1, setShownAc1] = useState("1");
  const [shownAc2, setShownAc2] = useState("1");
  const [cardsSettled, setCardsSettled] = useState(false);

  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "OneMeter_virtual"
  });
  //console.log(data);

  /// place bet ///

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const payloadResult = data?.data?.result;

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "OneMeter_virtual"
    });
    let books = res?.data;

    if (books !== null && books.length > 0) {
      for (let i = 0; i < books.length; i++) {
        let obj = books[i];
        if (obj.type === 1) {
          setPlayerABook(obj.profit);
          setPlayerALoss(obj.lib);
        } else {
          setPlayerBBook(obj.profit);
          setPlayerBLoss(obj.lib);
        }
      }
    }
  }
  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  useEffect(() => {
    if (!payload) return;
    updateUserData(data?.user);
    setDisplayLoader(false);

    if (lastStatus != payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]); //clearing placed bets on status change
      setWinnerA(false);
      setWinnerB(false);
      setIsPair1(false);
      setIsPair2(false);
      setPlayerABook(0);
      setPlayerBBook(0);
      setPlayerALoss(0);
      setPlayerBLoss(0);
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
    }
    if (lastStatus != payload.evt_status) {
      setLastStatus(payload.evt_status);
    }
    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds !== "number") return;

    setB1Val(payload?.b1);
    setB2Val(payload?.b2);
    setTimeLeft(serverSeconds);
    setRoundId(payload?.cat_mid);

    if (payload?.result == 1) {
      setWinnerA(true);
      setWinnerB(false);
    } else if (payload?.result == 2) {
      setWinnerA(false);
      setWinnerB(true);
    }

    if (payload?.isPair1 == 1) {
      setIsPair1(true);
    }
    if (payload?.isPair2 == 1) {
      setIsPair2(true);
    }

    clearInterval(localTimerRef.current);

    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  useEffect(() => {
    console.log("🔥 ACTIVE TAB CHANGED:", activeTabIndex);
  }, [activeTabIndex]);
  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "OneMeter_virtual";

    const response = await axiosInstance.post(
      "/teenpatti-results",
      resultObj
    );
    console.log("One Meter response:", response.data);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };

  // STAKE BUTTON CLICK
  function handleStakeClick(value) {
    const stakeInput = document.getElementById("casino_amount_web");

    let cleanValue = value.replace(/,/g, "");
    let current = parseInt(stakeInput.value) || 0;

    if (cleanValue.startsWith("+")) {
      stakeInput.value = current + parseInt(cleanValue.replace("+", ""));
    } else {
      stakeInput.value = parseInt(cleanValue);
    }
  }
  // CLEAR FUNCTION
  function clearBet() {
    document.getElementById("casino_amount_web").value = "";
    document.getElementById("span_profit_casino_web").innerText = "0";
  }

  function openBetSlip(odd) {
    setShowBetSlip(true);

    const oddsInput = document.getElementById("odd_casino_web");
    if (oddsInput) oddsInput.value = odd;
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const displayRunnerName = (runnerName) => {
    if (runnerName === "b1") {
      return "Player A";
    } else if (runnerName === "b2") {
      return "Player B";
    } else if (runnerName === "pairA") {
      return "Player A+";
    } else if (runnerName === "pairB") {
      return "Player B+";
    }
  };

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => {
    if (!payload?.evt_status) return;

    let cancelled = false;

    if (payload.evt_status === "OPEN") {
      clearTimeout(flipTimerRef.current);
      revealStartedForRef.current = null;
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);

      // Close Player A first, then Player B
      function closeA() {
        if (cancelled) return;
        setShownAc1("1");
        flipTimerRef.current = setTimeout(closeB, 1000);
      }
      function closeB() {
        if (cancelled) return;
        setShownAc2("1");
      }

      flipTimerRef.current = setTimeout(closeA, 300);
    }

    if (payload.evt_status === "CLOSED") {
      const c1 = payload?.ac1;
      const c2 = payload?.ac2;

      if (!c1 || c1 === "1") return;

      const roundKey = `${c1}|${c2}`;
      if (revealStartedForRef.current === roundKey) return;
      revealStartedForRef.current = roundKey;

      clearTimeout(flipTimerRef.current);
      setShownAc1("1");
      setShownAc2("1");

      // Reveal Player A first, then Player B
      function revealA() {
        if (cancelled) return;
        setShownAc1(c1);
        flipTimerRef.current = setTimeout(revealB, 1000);
      }
      function revealB() {
        if (cancelled) return;
        setShownAc2(c2);
      }

      flipTimerRef.current = setTimeout(revealA, 300);
    }

    return () => {
      cancelled = true;
      clearTimeout(flipTimerRef.current);
    };
  }, [payload?.evt_status, payload?.ac1, payload?.ac2]);

  useEffect(() => {
    const allRevealed =
      payload?.evt_status === "CLOSED" &&
      payload?.ac1 &&
      payload.ac1 !== "1" &&
      payload?.ac2 &&
      payload.ac2 !== "1" &&
      shownAc1 === payload.ac1 &&
      shownAc2 === payload.ac2;

    if (!allRevealed) {
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
      return;
    }

    clearTimeout(cardsSettleTimerRef.current);
    cardsSettleTimerRef.current = setTimeout(() => {
      setCardsSettled(true);
    }, 1000);

    return () => clearTimeout(cardsSettleTimerRef.current);
  }, [payload?.evt_status, payload?.ac1, payload?.ac2, shownAc1, shownAc2]);

  useEffect(
    () => () => {
      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
    },
    []
  );

  const showBetfairBetSlip = (bettype, teamname, selectRnr, price) => {
    let placeBetObject = {
      amount: 0,
      cat_mid: "",
      market_type: "m",
      game_name: "OneMeter_virtual"
    };
    placeBetObject.catmid = payload?.cat_mid;
    placeBetObject.round = payload?.cat_mid;

    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.selectRnr = selectRnr;
    placeBetObject.marketVal = 1;
    placeBetObject.game_type = 7;

    setPlaceBetObject(placeBetObject);
    //console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };

  useEffect(() => {
    if (!payload) return;
    updateUserData(data?.user);
    setDisplayLoader(false);

    if (lastStatus != payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]); //clearing placed bets on status change
      setWinnerA(false);
      setWinnerB(false);
      setIsPair1(false);
      setIsPair2(false);
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
    }
    if (lastStatus != payload.evt_status) {
      setLastStatus(payload.evt_status);
    }
    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds !== "number") return;

    setB1Val(payload?.b1);
    setB2Val(payload?.b2);
    setTimeLeft(serverSeconds);
    setRoundId(payload?.cat_mid);

    if (payload?.result == 1) {
      setWinnerA(true);
      setWinnerB(false);
    } else if (payload?.result == 2) {
      setWinnerA(false);
      setWinnerB(true);
    }

    if (payload?.isPair1 == 1) {
      setIsPair1(true);
    }
    if (payload?.isPair2 == 1) {
      setIsPair2(true);
    }

    clearInterval(localTimerRef.current);

    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  const [placedBets, setPlacedBets] = useState([]);
  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const placedBets = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "OneMeter_virtual"
    });

    setPlacedBets(placedBets.data);
  }

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      setInitialBetsFetched(true);
      getBook();
    }
  }, [payload]);

  const getCardImage = (cardValue, reveal) => {
    return reveal && cardValue && cardValue !== "1" ? cardValue : "1";
  };

  const capitalizeEachWord = (str) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };
  const closeBetSlip = () => {
    setShowBetSlip(false);
  };

  const [profileData, setProfileData] = useState(null);

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div className="aviator-scope player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content">
                        <div>
                          {" "}
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                            <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                              <p>ONE CARD METER</p>
                            </div>
                            <div
                              className="col-6 col-md-6 inline-block Gameidcol text-right"
                              style={{ marginTop: "4px" }}
                            >
                              <div
                                role="group"
                                aria-label="Second group"
                                className="btn-group btn-group-sm mr-2"
                              >
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="Alltab"
                                  className={
                                    activeTabIndex == 1
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(1)}
                                >
                                  Game
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="RESULTStab"
                                  className={
                                    activeTabIndex == 2
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => {
                                    console.log(
                                      "🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥RESULTS BUTTON CLICKED"
                                    );
                                    console.log(
                                      "ACTIVE TAB INDEX:",
                                      activeTabIndex
                                    );
                                    activeTab(2);
                                  }}
                                >
                                  Results
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  className="tablink btn btn-primary"
                                  onClick={() => setShowRules(true)}
                                >
                                  Rules
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <OneCardMeterRules
                          show={showRules}
                          onClose={() => setShowRules(false)}
                        />
                        <div
                          className="cards-layout blackjack"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div>
                            <div
                              className="cards-layout blackjack"
                              style={{ position: "relative" }}
                            >
                              <div className="col-12 timerDiv2 mb-negative-24">
                                <div
                                  className="row mt-2 timer-header-row"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <div className="timer-bettor-col">
                                    <div className="Connectedclients mt-1">
                                      <i
                                        aria-hidden="true"
                                        className="fa fa-user mr-1"
                                        style={{
                                          fontSize: "14px",
                                          color: "white"
                                        }}
                                      />
                                      <b>
                                        <span
                                          id="UsersCount"
                                          className="number"
                                        >
                                          53
                                        </span>
                                      </b>
                                    </div>
                                  </div>

                                  <div className="timer-countdown-col">
                                    <div className="teenpatti-base-timer">
                                      <svg
                                        viewBox="0 0 100 100"
                                        className="base-timer__svg"
                                      >
                                        <g className="base-timer__circle">
                                          <circle
                                            cx="50"
                                            cy="50"
                                            r="45"
                                            className="base-timer__path-elapsed"
                                          />
                                          <path
                                            strokeDasharray={`${Math.round(
                                              dash
                                            )} ${Math.round(CIRC)}`}
                                            className={`base-timer__path-remaining ${timerColor}`}
                                            d="
                                                M 50, 50
                                                m -45, 0
                                                a 45,45 0 1,0 90,0
                                                a 45,45 0 1,0 -90,0
                                              "
                                          />
                                        </g>
                                      </svg>
                                      <span className="base-timer__label">
                                        {timeLeft == 1 ? 0 : timeLeft}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="three-cards-wrapper">
                                <div class="player-containerHC">
                                  <div class="player-itemHC">
                                    <span class="player-nameHC">Player A</span>
                                    <div class="player-cardHC">
                                      <div
                                        id="BFBCardFanView"
                                        class="card-viewHC"
                                      >
                                        <div>
                                          <img
                                            src={`/assets/images/cards/${getCardImage(
                                              shownAc1,
                                              true
                                            )}.svg`}
                                            draggable={false}
                                            style={{
                                              width: isMobile ? "46px" : "60px",
                                              height: isMobile ? "55px" : "75px"
                                            }}
                                            className="animate__animated animate__flipInY"
                                            key={shownAc1}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="player-containerHC">
                                  <div class="player-itemHC">
                                    <span class="player-nameHC">Player B</span>
                                    <div class="player-cardHC">
                                      <div
                                        id="BFBCardFanView"
                                        class="card-viewHC"
                                      >
                                        <div>
                                          <img
                                            src={`/assets/images/cards/${getCardImage(
                                              shownAc2,
                                              true
                                            )}.svg`}
                                            draggable={false}
                                            style={{
                                              width: isMobile ? "46px" : "60px",
                                              height: isMobile ? "55px" : "75px"
                                            }}
                                            className="animate__animated animate__flipInY"
                                            key={shownAc2}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <Volume
                                id="OneCardMeterSoundcontrol"
                                style={{
                                  position: "absolute",
                                  right: 18,
                                  bottom: 8,
                                  zIndex: 100,
                                  transform: "scale(0.8)",
                                  transformOrigin: "center",
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                              />
                              {/* Controls removed (auto mode) */}
                            </div>
                          </div>
                        </div>

                        {/* Footer */}
                        <center
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                            <div className="buttons-div">
                              {[
                                "A",
                                "A",
                                "A",
                                "A",
                                "B",
                                "B",
                                "B",
                                "A",
                                "A",
                                "B"
                              ].map((btn, idx) => (
                                <button
                                  key={idx}
                                  className="video-button border-gradient-btn border-gradient-purple-btn"
                                >
                                  {btn}
                                </button>
                              ))}
                            </div>
                            <div className="round-div">
                              <div className="label">Round ID:</div>
                              <div className="id">{roundId}</div>
                            </div>
                          </div>
                        </center>

                        {/* Market Sections (unchanged) */}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div class="market-titlebar">
                              <p class="market-name">
                                <span class="market-name-badge">
                                  <i class="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>MATCH ODDS </span>
                                </span>
                              </p>
                              <div class="market-overarround">
                                <span></span>
                                <strong>Back</strong>
                              </div>
                              <div class="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div class="market-runners">
                              <div
                                className="runner-runner"
                                style={{ height: "auto" }}
                              >
                                <h3
                                  className={
                                    winnerA && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b1Sucess"
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontWeight: "bold",
                                                  fontSize: "16px"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Player A
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    playerABook !== 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    playerABook > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(playerABook)}/
                                              </div>

                                              <div
                                                id="bstatus1"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    playerALoos !== 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    playerALoos > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(playerALoos)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Player A"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "player a",
                                        "player a",
                                        b1Val
                                      )
                                    }
                                  >
                                    {b1Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div
                                className="runner-runner"
                                style={{ height: "auto" }}
                              >
                                <h3
                                  className={
                                    winnerB && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b2Sucess"
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontWeight: "bold",
                                                  fontSize: "16px"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Player B
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus2"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    playerBBook !== 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    playerBBook > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(playerBBook)} /
                                              </div>

                                              <div
                                                id="bstatus2"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    playerBLoss !== 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    playerBLoss > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(playerBLoss)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b2span"
                                    data-teamname="Player B"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "player b",
                                        "player b",
                                        b2Val
                                      )
                                    }
                                  >
                                    {b2Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            style={{ height: "5px", backgroundColor: "#000" }}
                          ></div>
                        </div>
                        <div
                          style={{
                            display: activeTabIndex == 2 ? "block" : "none",
                            width: "100%"
                          }}
                        >
                          <OneCardMeterResult resultData={resultData} />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 mobile-margin">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}
                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      ></TeenPattisCasinoBetslipWeb>

                      {showBetSlip && isMobile && (
                        <div className="mobile-overlay">
                          <div className="mobile-modal">
                            <div class="modal-body">
                              <table>
                                <tbody>
                                  <tr>
                                    <td>&nbsp;</td>
                                    <th colspan="3">Total 1</th>
                                  </tr>
                                  <tr>
                                    <td>ODDS</td>
                                    <td colspan="2">
                                      <div class="input-group mt-2">
                                        <div class="input-group-prepend">
                                          <button
                                            type="button"
                                            class="btn btn-outline-secondary"
                                          >
                                            <strong>-</strong>
                                          </button>
                                        </div>
                                        <input
                                          type="number"
                                          id="bet-price"
                                          step="0.01"
                                          min="1.01"
                                          max="1000"
                                          class="form-control"
                                        />
                                        <div class="input-group-append">
                                          <button
                                            type="button"
                                            class="btn btn-outline-secondary"
                                          >
                                            <strong>+</strong>
                                          </button>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Amount</td>
                                    <td colspan="2">
                                      <input
                                        type="number"
                                        id="bet-size-m"
                                        class="form-control mt-2"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "25%" }}>
                                      <button
                                        type="button"
                                        data-amount="2000"
                                        class="btn btn-secondary btn-block mt-2"
                                        style={{
                                          touchAction: "manipulation"
                                        }}
                                      >
                                        2,000
                                      </button>
                                    </td>
                                    <td style={{ width: "25%" }}>
                                      <button
                                        type="button"
                                        class="btn btn-secondary btn-block mt-2"
                                        style={{
                                          touchAction: "manipulation"
                                        }}
                                      >
                                        5,000
                                      </button>
                                    </td>
                                    <td style={{ width: "25%" }}>
                                      <button
                                        type="button"
                                        class="btn btn-secondary btn-block mt-2"
                                        style={{
                                          touchAction: "manipulation"
                                        }}
                                      >
                                        10,000
                                      </button>
                                    </td>
                                    <td style={{ width: "25%" }}>
                                      <button
                                        type="button"
                                        class="btn btn-secondary btn-block mt-2"
                                        style={{
                                          touchAction: "manipulation"
                                        }}
                                      >
                                        50,000
                                      </button>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <button
                                        type="button"
                                        class="btn btn-secondary btn-block mt-2"
                                        style={{
                                          touchAction: "manipulation"
                                        }}
                                      >
                                        +1,000
                                      </button>
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        class="btn btn-secondary btn-block mt-2"
                                        style={{
                                          touchAction: "manipulation"
                                        }}
                                      >
                                        +5,000
                                      </button>
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        class="btn btn-secondary btn-block mt-2"
                                        style={{
                                          touchAction: "manipulation"
                                        }}
                                      >
                                        +10,000
                                      </button>
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        class="btn btn-secondary btn-block mt-2"
                                        style={{
                                          touchAction: "manipulation"
                                        }}
                                      >
                                        +25,000
                                      </button>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <button
                                        type="button"
                                        data-dismiss="modal"
                                        class="btn btn-danger mt-2"
                                        style={{
                                          touchAction: "manipulation"
                                        }}
                                        onClick={closeBetSlip}
                                      >
                                        Close
                                      </button>
                                    </td>
                                    <td colspan="2">
                                      <div
                                        class="btn btn-primary ld-over mt-2"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <b>Submit</b>
                                        <div class="ld ld-ball ld-flip"></div>
                                      </div>
                                      <span>0 / -0</span>
                                    </td>
                                  </tr>
                                  <tr style={{ display: "none" }}>
                                    <td
                                      colspan="4"
                                      class="alert-danger pr-5"
                                    ></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                      <div>
                        <div className="bets">
                          <strong>
                            Matched Bets (0)
                            <img
                              src={reconnecting}
                              alt="dc"
                              className="rounded disconnected"
                              style={{ display: "none" }}
                            />{" "}
                          </strong>
                          <div className="betting-table">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Runner</th>
                                  <th>Price</th>
                                  <th>Size</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {placedBets.map((bet, index) => {
                                  console.log("MATCHED BET:", bet);

                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        background:
                                          bet.type == "b"
                                            ? "#e9f6fc"
                                            : "#fce3e4"
                                      }}
                                    >
                                      <td>
                                        {displayRunnerName(bet.rnr)} - (
                                        {bet.cat_mid})
                                      </td>

                                      <td>{bet.amnt}</td>
                                      <td>{bet.rate}</td>
                                      <td></td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
      <style>
        {`
          .player-containerHC {
            display: inline-flex;
            flex-direction: column;
            margin: 5px;
          }
          .three-cards-wrapper{
            display:flex;
            justify-content:center;
            align-items:flex-start;
            gap:1px;
            width:100%;
            margin-top: 20px;
          }
          .volume-wrapper {
            margin-top: -25px;
          }
          @media (min-width: 992px) {
            .aviator-scope .row {
              margin-left: 0 !important;
              margin-right: 0 !important;
            }
          }
          @scope (.aviator-scope) {
            .home-content {
              margin-top: 0 !important;
            }
            .cards-layout.blackjack {
              position: relative;
              min-height: 210px;
              background: #000000 !important;
            }
            .cards-layout.blackjack::before {
              content: "";
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              background: radial-gradient(
                ellipse 100% 44% at 50% calc(30% + 40px),
                rgba(62, 193, 65, 0.95) 0%,
                rgba(62, 193, 65, 0.8) 15%,
                rgba(30, 80, 35, 0.5) 40%,
                #1e1e1e 55%,
                #1e1e1e 100%
              );
              opacity: 0.4;
              pointer-events: none;
              z-index: 0;
            }
            .cards-layout.blackjack > * {
              position: relative;
              z-index: 1;
            }
            .blackjack {
              background: #000000 !important;
            }
            .timerDiv2 {
              padding-left: 5px;
              padding-right: 0;
            }
            .timerDiv2 .timer-header-row {
              display: flex;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              margin-left: 0;
              margin-right: 0;
            }
            .timerDiv2 .timer-bettor-col,
            .timerDiv2 .timer-countdown-col {
              flex: 0 0 auto;
              width: auto;
              max-width: none;
              padding: 0;
            }
            .timerDiv2 .timer-bettor-col {
              position: relative;
              top: -17px;
              left: 10px;
            }
            .timerDiv2 .Connectedclients {
              position: static;
            }
            .timerDiv2 .timer-countdown-col {
              margin-left: auto;
              position: relative;
              top: -7px;
            }
            .timerDiv2 .teenpatti-base-timer {
              position: relative;
              width: 50px;
              height: 50px;
            }
            .timerDiv2 .teenpatti-base-timer .base-timer__label {
              position: absolute;
              inset: 0;
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          @media (max-width: 576px) {
            .mobile-margin{
              margin-top: 8px;
            }
          }
            .mobile-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(0,0,0,0.5);
                        z-index: 9999;
                    }
                    .mobile-modal {
                        position: fixed;
                        top: 10px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 95%;
                        max-width: 420px;
                        background: #dfe7ee; 
                        border-radius: 6px;
                        padding: 15px;
                        box-shadow: 0 4px 15px rgba(0,0,0,0.3);
                        animation: slideDown 0.25s ease;
                    }
                    @keyframes slideDown {
                        from {
                            transform: translate(-50%, -30%);
                            opacity: 0;
                        }
                        to {
                            transform: translate(-50%, 0);
                            opacity: 1;
                        }
                    }
          `}
      </style>
    </div>
  );
}
